import { Injectable, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute, Navigation, Router } from '@angular/router'
import { UserService } from '../services/user.service'
import { SharedService } from '../services/shared.service'
import { PageEvent } from '@angular/material/paginator'
import { RouterPath } from '../../config/global-const'
import { PvsResponse } from '../services/pvs-request.service'
import _ from 'lodash'
import { fromEvent } from 'rxjs'

@Injectable()
export abstract class BasePageComponent implements OnInit, OnDestroy {
    public currentSalon: any
    /**
     * Current salon Id. The Id of the salon that selected on top bar.
     */
    public salonId: number
    /**
     * Redirect to the error page if the user has no salon (currentSalon is null)
     */
    public checkNoSalon: boolean = true
    public queryParams: any
    public pathParams: any
    public pageEvent: PageEvent = {
        pageIndex: 0,
        previousPageIndex: -1,
        pageSize: 20,
        length: 0,
    }
    public currentNavigation: Navigation
    public currentState: any

    protected constructor(
        public router: Router,
        public route: ActivatedRoute,
        public sharedService: SharedService,
        public userService: UserService,
        public autoGetParamsFromUrl: boolean = true
    ) {
        this.sharedService.resetLoadingCount()
        this.currentNavigation = this.router.getCurrentNavigation()
        this.currentState = this.currentNavigation?.extras?.state || {}
    }

    ngOnInit() {
        if (this.autoGetParamsFromUrl) {
            this.sharedService.getParamsFromUrl(this.route, this.queryParams, this.pathParams, this.pageEvent)
        }
        // handle: reload data when user go back history on browser
        fromEvent(window, 'popstate').subscribe(() => {
            this.sharedService.getParamsFromUrlByWindow(this.queryParams, this.pathParams, this.pageEvent)
            this.onGoBackBrowserChanged()
        })
        this.userService.getCurrentSalon().then((res) => {
            this.currentSalon = this.sharedService.currentSalon
            if (this.checkNoSalon) {
                if (!this.currentSalon) {
                    return void this.router.navigate([RouterPath.ERRORS.NO_SALON.FULL_PATH])
                }
            }
            this.salonId = this.currentSalon?.id ?? null
            this.onInit()
        })
    }
    onInit() {}
    ngOnDestroy() {
        this.onDestroy()
    }
    onDestroy() {}

    onGoBackBrowserChanged() {}

    setParamsToUrl(writeHistory: boolean = false) {
        this.sharedService.setParamsToUrl(this.router, this.queryParams, this.pathParams, this.pageEvent, writeHistory)
    }

    setPagingFromResponse(res: PvsResponse) {
        return this.sharedService.setPagingFromResponse(this.pageEvent, res)
    }
    buildQueryParams(
        queryParam: any,
        pageEvent: PageEvent,
        trimParam: boolean = true,
        removeBlankParams: boolean = true
    ): any {
        const result: any = {}
        for (const key of Object.keys(queryParam)) {
            let value = queryParam[key]
            if (trimParam && typeof value === 'string') {
                value = value.trim()
            }
            if (removeBlankParams && !value) {
                // do nothing
            } else {
                result[key] = value
            }
        }
        if (_.isInteger(parseInt(String(pageEvent?.pageIndex)))) {
            result.page = pageEvent.pageIndex + 1
        }
        if (_.isInteger(parseInt(String(pageEvent?.pageSize)))) {
            result.limit = pageEvent.pageSize
        }
        return result
    }
}
